import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useAuthContext } from '../Context/AuthContext';
import { useRequest } from '../Context/RequestContext';

const useCategoriesAdmin = () => {
    const { user } = useAuthContext();
    const { Request } = useRequest();
    const [categories, setCategories] = useState({
        current_page: 1,
        data: [],
        links: [],
        total: 0
    })
    const [modal, setModal] = useState(false)
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getData()
    }, [])

    const getData = (url = 'admin/categories') => {
        setLoading(true);
        Request({ url }).then((response) => {
            setLoading(false);
            if (response.status === 200) {
                setCategories(response.data);
            } else {
                toast.error(response.statusText)
            }
        })
    }

    const add = (data) => {
        setLoading(true);
        Request({ data, url: 'admin/add-category' }).then((response) => {
            setLoading(false);
            if (response.status === 200) {
                setModal(false)
                getData()
            }
        })
    }
    const remove = (id) => {
        setLoading(true);
        Request({ data: { id }, url: 'admin/delete-category' }).then((response) => {
            setLoading(false);
            if (response.status === 200) {
                let newCategories = { ...categories, data: [...categories.data].filter((category) => category.id != id) };
                setCategories(newCategories);
            }

        })
    }
    return { getData, add, categories, remove, user, modal, setModal, loading, setLoading }
}

export default useCategoriesAdmin